import { API, Auth } from 'aws-amplify';
import { AxiosError } from 'axios';

import { sortOrderByPrice } from '../elasticSearch/sortScripts';
import { getConfig } from '../config';
import {
  Order,
  OrderBookingOption,
  OrderHistoryRecord,
  OrderPaymentDetails,
  OrderRefundPayload,
  OrderRequestRefundPayload,
} from '../types/Order';
import { OrderUpdateOption } from '../types/OrderUpdateOption';

/* eslint-disable consistent-return */
export async function getAllOrders(sort, filterData, from, getAll) {
  try {
    let query = {
      bool: { must_not: [{ term: { 'status.keyword': 'Draft' } }] },
    };
    if (filterData) {
      const terms = [];
      if (filterData.status.length > 0) {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        terms.push({ term: { 'status.keyword': filterData.status } });
      }
      if (filterData.fromDate && filterData.fromDate !== '') {
        const date = filterData.fromDate;
        date.setUTCHours(0, 0, 0, 0);
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        terms.push({
          range: { created: { gte: date.toISOString() } },
        });
      }
      if (filterData.toDate && filterData.toDate !== '') {
        const date = filterData.toDate;
        date.setUTCHours(23, 59, 59, 999);
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        terms.push({
          range: { created: { lte: date.toISOString() } },
        });
      }

      if (filterData.startDateTime && filterData.startDateTime !== '') {
        const date = filterData.startDateTime;
        date.setUTCHours(0, 0, 0, 0);
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        terms.push({
          range: {
            startDateTime: { gte: date.toISOString() },
          },
        });
      }
      if (filterData.endDateTime && filterData.endDateTime !== '') {
        const date = filterData.endDateTime;
        date.setUTCHours(23, 59, 59, 999);
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        terms.push({
          range: { endDateTime: { lte: date.toISOString() } },
        });
      }

      if (filterData.name.length >= 3) {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        terms.push({ match_phrase_prefix: { name: `#${filterData.name}` } });
      }
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      query = { bool: { ...query.bool, must: terms } };
    }
    const property = sort.isString ? `${sort.name}.keyword` : sort.name;
    let srt;
    if (property === 'totalPrice.keyword') {
      srt = sortOrderByPrice(sort);
    } else {
      srt = [{ [property]: sort.up ? 'asc' : 'desc' }];
    }
    const responseUrl = await API.post('party', '/orders/adminSearch', {
      body: {
        from,
        size: getAll ? 10000 : 25,
        sort: srt,
        query,
      },
    });
    const responseValue = await fetch(responseUrl);
    const data = await responseValue.json();
    return data;
  } catch (e) {
    console.error(e);
    const error = e as AxiosError;
    alert(
      `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
    );
  }
}

export async function getOrdersByActivity(activityId, sort) {
  try {
    const property = sort.isString ? `${sort.name}.keyword` : sort.name;
    let srt;
    if (property === 'totalPrice.keyword') {
      srt = sortOrderByPrice(sort);
    } else {
      srt = [{ [property]: sort.up ? 'asc' : 'desc' }];
    }
    const responseUrl = await API.post('party', '/orders/adminSearch', {
      body: {
        from: 0,
        size: 250,
        sort: srt,
        query: {
          bool: {
            must: {
              match: { 'activityId.keyword': activityId },
            },
            must_not: [{ term: { 'status.keyword': 'Draft' } }],
          },
        },
      },
    });
    const responseValue = await fetch(responseUrl);
    const data = await responseValue.json();
    return data;
  } catch (e) {
    console.error(e);
    const error = e as AxiosError;
    alert(
      `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
    );
  }
}

export async function getOrdersByParty(partyId, sort) {
  try {
    const property = sort.isString ? `${sort.name}.keyword` : sort.name;
    let srt;
    if (property === 'totalPrice.keyword') {
      srt = sortOrderByPrice(sort);
    } else {
      srt = [{ [property]: sort.up ? 'asc' : 'desc' }];
    }
    const responseUrl = await API.post('party', '/orders/adminSearch', {
      body: {
        from: 0,
        size: 250,
        sort: srt,
        query: {
          bool: {
            must: {
              match: { partyId },
            },
          },
        },
      },
    });
    const responseValue = await fetch(responseUrl);
    const data = await responseValue.json();
    return data;
  } catch (e) {
    console.error(e);
    const error = e as AxiosError;
    alert(
      `Error code: ${error?.response?.status} \nError message: ${error?.response?.data}`
    );
  }
}

export function getOrdersByDates(dateFrom, dateTo) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get(
    'party',
    `/orders?${dateFrom ? `dateFrom=${dateFrom}` : ''}${
      dateTo ? `&dateTo=${dateTo}` : ''
    }`
  );
}

export function getOrderById(orderId): Promise<Order> {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/orders/${orderId}`);
}

export function getOrderPaymentDetails(
  orderId: string
): Promise<OrderPaymentDetails[]> {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/orders/${orderId}/payment-details`);
}

export function getOrderUpdateOptions(
  activityId: string,
  bookingOptions: OrderBookingOption[],
  orderId: string,
  startDateTime: string,
  endDateTime: string
): Promise<OrderUpdateOption[]> {
  return API.post('party', '/orders/requestOrderUpdateOptions', {
    body: {
      activityId,
      bookingOptions,
      orderId,
      startDateTime,
      endDateTime,
    },
  }).catch(e => {
    const axiosError = e as AxiosError;
    throw new Error(axiosError.response?.data || e.message);
  });
}

export function getOrder(
  activityId,
  partyId,
  partyName,
  tz,
  eventId,
  bookingOptions,
  startDateTime,
  endDateTime,
  bookingOwner
) {
  return API.post('party', '/orders', {
    body: {
      activityId,
      partyId,
      partyName,
      tz,
      eventId,
      bookingOptions,
      startDateTime,
      endDateTime,
      bookingOwner,
      concierge: true,
    },
  });
}

export function applyPromoCode(draftActivity, promoCode) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.post(
    'party',
    `/orders/${draftActivity?.id}/applyDiscount/${promoCode}`
  );
}

export async function chargeOrder(orderId, cardId) {
  // use standard fetch method here
  // because backend expects to get string in the request body
  // but aws-amplify always serializes it to JSON
  const config = getConfig();
  const baseUrl = config.apiGateway.URL;
  const token = await Auth.currentSession();
  return fetch(`${baseUrl}/orders/${orderId}/charge`, {
    method: 'PUT',
    body: cardId,
    headers: {
      'accept-encoding': 'gzip, deflate, *',
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      authorization: token.idToken.jwtToken,
      'content-type': 'text/plain',
    },
  });
}

export function getOrderCharges(orderId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/orders/${orderId}/charges`);
}

export function getOrderHistory(orderId): Promise<OrderHistoryRecord[]> {
  return API.get('party', `/orders/${orderId}/history`, {});
}

export const refundOrder = (orderId: string, payload: OrderRefundPayload) => {
  return API.post('party', `/orders/${orderId}/refund`, {
    body: payload,
  });
};

export function requestPartialRefund(
  orderId: string,
  payload: OrderRequestRefundPayload
) {
  return API.post('party', `/orders/${orderId}/request-partial-refund`, {
    body: payload,
  });
}

export function fulfillOrder(orderId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.post('party', `/orders/${orderId}/fulfill`);
}

export function cancelOrderFulfillment(orderId, reason, reasonNote) {
  return API.post('party', `/orders/${orderId}/cancel`, {
    body: {
      reason,
      reasonNote,
    },
  });
}

export function updateOrder(id, fields) {
  return API.patch('party', `/orders/${id}`, {
    body: fields,
  });
}

export function createNewCard(orderId, cardholderId) {
  return API.post('party', '/issuing/card', {
    body: {
      orderId,
      cardholder: cardholderId,
    },
  });
}

export function getCardDetails(cardId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/issuing/card/${cardId}`);
}

export function getTransactionLedger(orderId) {
  // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
  // @ts-ignore
  return API.get('party', `/issuing/transaction/getByOrder/${orderId}`);
}
